module.exports = " <div class=suggest-fieldtype-wrapper> <div v-if=loading class=\"loading loading-basic\"> <span class=\"icon icon-circular-graph animation-spin\"></span> {{ translate('cp.loading') }} </div> <select v-if=!loading :name=name :placeholder=\"translate('cp.please_select')\" :multiple=true> </select> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/fieldtypes/SuggestFieldtype.vue
// module id = 749
// module chunks = 0